import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import API from '../apiConfig';

function Home() {
  const [featuredPosts, setFeaturedPosts] = useState([]);

  useEffect(() => {
    const fetchFeaturedPosts = async () => {
      try {
        const response = await axios.get(API.posts.fetchFeatured());
        setFeaturedPosts(response.data);
      } catch (error) {
        console.error('Error fetching featured posts:', error);
      }
    };

    fetchFeaturedPosts();
  }, []);

  return (
    <div>
      <div className="jumbotron bg-light p-5 rounded-3 mb-4">
        <h1 className="display-4">Welcome to MedikaHub</h1>
        <p className="lead">Your trusted source for medical information and community.</p>
        <hr className="my-4" />
        <p>Explore our latest posts or join our community today.</p>
        <Link to="/posts" className="btn btn-primary btn-lg">View All Posts</Link>
      </div>

      <h2 className="text-center mb-4">Featured Posts</h2>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {featuredPosts.map(post => (
          <div key={post.id} className="col">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">{post.title}</h5>
                <p className="card-text">{post.content.substring(0, 100)}...</p>
              </div>
              <div className="card-footer">
                <Link to={`/posts/${post.id}`} className="btn btn-sm btn-outline-primary">Read More</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
